import { sign_in_event } from 'gtm/pushEvents'
import { change_braze_user } from 'braze/brazeEvents'

export const sendAccessTokenToApp = ({
  email,
  accessTokens = undefined,
  error = false,
  linkedUser = false,
  user = {},
  method,
  isVerifyWebViewSuccess = false,
  isSignUpWebViewSuccess = false,
  isExistingAwcUser
}) => {
  if (!Boolean(error)) {
    sign_in_event({ aa_linked_user: linkedUser, method, user })
    change_braze_user(user)
  }
  const data = Boolean(error)
    ? { errorMessage: error }
    : {
        email,
        accessTokens,
        isVerifyWebViewSuccess,
        isSignUpWebViewSuccess,
        isExistingAwcUser,
        user
      }
  // iOS should have a listener for this
  window.webkit?.messageHandlers?.tokenHandler?.postMessage(data)
}

export const createKeyDownHandler = () => (e) => {
  const allowedKeys = ['Backspace', 'Delete']

  if (allowedKeys.includes(e.key)) return

  if (!/^\d$/.test(e.key)) {
    e.preventDefault()
  }
}

export const createPasteHandler =
  ({ onPasteComplete }) =>
  (e) => {
    e.preventDefault()
    const pastedData = e.clipboardData.getData('Text')
    const numericData = pastedData.replace(/\D/g, '').slice(0, 5)

    if (!numericData) return

    onPasteComplete(numericData)
  }
